import React from 'react';
import { Icon, IconType, Theme } from '@routific/hive';

const PreviousIcon: React.FC = () => {
  return <Icon icon={IconType.Back} style={{ color: Theme.Colors.primary5 }} />;
};

export default PreviousIcon;
